/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".title[_ngcontent-%COMP%]{color:#002c7c;font-weight:700;text-align:left;width:94%;display:block;margin:0 auto}  .btn-group{padding:0!important;display:-webkit-box!important;display:flex!important;-webkit-box-pack:center!important;justify-content:center!important}  .btn-group .btn{font-size:1.6rem;font-weight:700;color:#ff720a;background-color:#fff;margin:8px -1px!important;border:1px solid #ff720a;width:49%;padding:9px!important}  .btn-group .btn.active,   .btn-group .btn:hover{background-color:#ff720a;color:#fff;border-color:transparent}"];
export { styles as styles };
